import { FieldModel } from 'shared/models/form';

import { normalizeScenarioData } from '../scenario';

import { IAIBotScenarioData } from './client';
import { AIBotScenarioDataServer } from './server';

/**
 *
 * @param raw channel_ids
 * @returns [] - пустой массив, если не пришло поле или пришел пустой массив
 * @returns null - если пришло null - подключены все каналы проекта
 * @returns ['id1', 'id2'] - подключенные каналы
 */
export const normalizeAIBotChannelIds = (raw: string[] | null | undefined) => {
  return raw === null ? null : (raw ?? []);
};

export const normalizeAIBotScenarioData = (
  raw: AIBotScenarioDataServer
): IAIBotScenarioData => {
  return {
    channelIds: new FieldModel<string[] | null>(
      normalizeAIBotChannelIds(raw.channel_ids)
    ),
    ...normalizeScenarioData(raw)
  };
};
